module.exports = __webpack_public_path__ + "static/media/motivation3.6a1e12ea.png";